export const ErrorLoading = ( {error }: {error: string}) => {
  return (
    <div className="flex w-full flex-col items-center justify-center py-10">
      <h3 className="text-2xl font-semibold text-foreground mb-2">
        Error Loading Sub-Accounts
      </h3>
      <p className="text-red-500 text-center text-sm">
        {error}
      </p>
    </div>
  )
}